import { useFirestoreDoc } from "@p0security/frontend-core/react";
import type { AutoApprover } from "@p0security/shared/types/policy/types";
import { compact } from "lodash";
import { useMemo } from "react";

export const useInstalledApprovers = (): AutoApprover[] => {
  const pd = useFirestoreDoc("integrations/pagerduty", {
    live: false,
    tenantAware: true,
  });
  const io = useFirestoreDoc("integrations/incidentio", {
    live: false,
    tenantAware: true,
  });
  const irm = useFirestoreDoc("integrations/grafana-irm", {
    live: false,
    tenantAware: true,
  });
  return useMemo(
    () =>
      compact([
        !!pd.doc?.data && "pagerduty",
        !!io.doc?.data && "incidentio",
        !!irm.doc?.data && "grafana-irm",
      ]),
    [pd.doc?.data, io.doc?.data, irm.doc?.data]
  );
};
